import { NgModule } from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule,ReactiveFormsModule} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
// SERVICIO AUTORIZACION E INTERCEPTION DE TOKEN
import { AuthGuard } from 'app/auth/auth.guard';
//componentes material Angular
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from "@angular/flex-layout";
import { Requerimientos3Service } from './requerimientos3.service';
import {MatDividerModule} from '@angular/material/divider';
import {MatIconModule} from '@angular/material/icon';
import {MatCardModule} from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatButtonModule} from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';
//     Componentes plataforma
import { Requerimientos3Component } from './requerimientos3.component';
import { LandingRequerimientosModule} from 'app/main/pagina/landingProducto/landing-requerimientos/landing-requerimientos.module';
import { ConfiCorreoComponent } from './confi-correo/confi-correo.component'
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { NewRTDominiosComponent } from './new-rtdominios/new-rtdominios.component';
import { NewRTDemoComponent } from './new-rtdemo/new-rtdemo.component';
import { FormAyudaComponent } from './form-ayuda/form-ayuda.component';
import {MatDialogModule} from '@angular/material/dialog';
const routes = [
  // requerimientos tecnicos detalle
  {
    path     : 'requirements-details/:idProducto/:empresaId',
    component: Requerimientos3Component
  },
  // requerimientos tecnicos detalle con idioma
  {
    path     : 'requirements-details/:idProducto/:empresaId/lang/:lang',
    component: Requerimientos3Component
  },
  {  //certificar 3.0
      path     : 'requerimentsLandingcertify_3/requirements-details',
      data : {producto : 'c3'},
      component: Requerimientos3Component,
      canActivate: [AuthGuard]
  },
  {  //certificar Plata
      path     : 'requerimentsLandingcertify_4/requirements-details',
      component: Requerimientos3Component,
      data : {producto : 'c4Plata'},
      canActivate: [AuthGuard]
  },
  {  //gptw gcti
      path     : 'requerimentsLandingcertify_6/requirements-details',
      component: Requerimientos3Component,
      data : {producto : 'c6'},
      canActivate: [AuthGuard]
  },
  {   //medir 3.0
      path     : 'requerimentsLandingmeasurement_t7/requirements-details',
      component: Requerimientos3Component,
      data : {producto : 'm7'},
      canActivate: [AuthGuard]
  },
  {
      path     : 'requerimentsLandingPulse_t1/adminpulsecheck/requirements-details',
      component: Requerimientos3Component,
      canActivate: [AuthGuard]
  },
  {
      path     : 'requerimentsLandingfocus/adminfocusarea/requirements-details',
      component: Requerimientos3Component,
      canActivate: [AuthGuard]
  },
  {
      path     : 'requirements-details',
      component: Requerimientos3Component,
      canActivate: [AuthGuard]
  },
  {
      path     : 'requirements-details/confirmCorreo/:idEmpresa/:idProducto',
      component: ConfiCorreoComponent,

  },
  {//versión anterior de dominios demo;
      path     : 'platafotm/:id/:idInstituto',
      component: NewRTDominiosComponent,

  },
  {//versión nueva de dominios demo
      path     : 'domains-ext/:idInstituto',
      component: NewRTDominiosComponent,

  },
  {
      path     : 'demo/:id',
      component: NewRTDemoComponent,

  },
  {  //AMCO 3.0
      path     : 'requerimentsLandingamco_1/requirements-details',
      component: Requerimientos3Component,
      data : {producto : 'am1'},
      canActivate: [AuthGuard]
  },
  {  //Trabajo digno 3.0
      path     : 'requerimentsLandingtraba_digno/requirements-details',
      component: Requerimientos3Component,
      data : {producto : 'td1'},
      canActivate: [AuthGuard]
  },
  {  //Primer empleo 3.0
      path     : 'requerimentsLandingprimer_emple/requirements-details',
      component: Requerimientos3Component,
      data : {producto : 'pe1'},
      canActivate: [AuthGuard]
  },
  {  //Primer empleo 3.0
      path     : 'requerimentsLandingNom35/requirements-details',
      component: Requerimientos3Component,
      canActivate: [AuthGuard]
  },
];

@NgModule({
  declarations: [Requerimientos3Component, ConfiCorreoComponent, NewRTDominiosComponent, NewRTDemoComponent, FormAyudaComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatStepperModule,
    MatTabsModule,
    TranslateModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    MatDividerModule,
    MatIconModule,
    MatCardModule,
    MatFormFieldModule,
    MatProgressBarModule,
    MatInputModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    LandingRequerimientosModule,
    MatButtonModule,
    MatTooltipModule,
    MatRadioModule,
    MatListModule,
    MatDialogModule,
  ],
  entryComponents: [FormAyudaComponent],
})
export class Requerimientos3Module { }
